const PATH_A = [
  { y: "Y1–2", t: "Same processes. Rising costs. Hiring more people to do what software should be doing for you." },
  { y: "Y3–5", t: "AI-enabled competitors capture the customers who want instant response. You compete on price alone." },
  { y: "Y5–10", t: "Businesses that built data intelligence in 2025 now own their markets. Acquiring a customer costs you 6× more." },
];

const PATH_B = [
  { y: "Y1", t: "Aria handles 80% of routine tasks. 15–20 hours/week recovered. Every lost lead becomes recovered revenue." },
  { y: "Y2–3", t: "Your data builds a moat. Predictions sharpen. Retention climbs. Word-of-mouth compounds quietly." },
  { y: "Y5–10", t: "You're the most trusted, most responsive name in your market. Your data justifies expansion. Competitors study you." },
];

const Vision = () => (
  <section id="vision" className="section bg-grey" data-bg="grey" data-testid="vision-section">
    <div className="section-inner">
      <div className="reveal">
        <span className="eyebrow">The Oracle's View</span>
        <h2 className="section-h2">
          Two futures.<br />
          <span className="serif">You choose.</span>
        </h2>
        <p className="section-sub">
          Every business owner faces this fork. The gap widens every single
          month you wait.
        </p>
      </div>

      <div className="paths-grid">
        <div className="path-card path-a reveal" data-testid="path-without-ai">
          <span className="path-eyebrow">Path A · Without AI</span>
          <h3 className="path-title">
            The slow <span className="serif">unraveling</span>.
          </h3>
          <div className="path-steps">
            {PATH_A.map((s, i) => (
              <div key={i} className="path-step">
                <span className="path-step-year">{s.y}</span>
                <span className="path-step-text">{s.t}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="path-card path-b reveal" data-testid="path-with-aria">
          <span className="path-eyebrow">Path B · With Aria</span>
          <h3 className="path-title">
            The quiet <span className="serif">compounding</span>.
          </h3>
          <div className="path-steps">
            {PATH_B.map((s, i) => (
              <div key={i} className="path-step">
                <span className="path-step-year">{s.y}</span>
                <span className="path-step-text">{s.t}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Vision;
